'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = require('@pixi/core');
var Container = require('./Container.js');

Object.defineProperties(core.settings, {
  SORTABLE_CHILDREN: {
    get() {
      return Container.Container.defaultSortableChildren;
    },
    set(value) {
      core.utils.deprecation("7.1.0", "settings.SORTABLE_CHILDREN is deprecated, use Container.defaultSortableChildren");
      Container.Container.defaultSortableChildren = value;
    }
  }
});

Object.defineProperty(exports, 'settings', {
    enumerable: true,
    get: function () { return core.settings; }
});
//# sourceMappingURL=settings.js.map
